import colors from "@/constants/Colors";
import { memo } from '@fantastic-utils/memo';

export const colorResolver = memo((option) => {

    const { type = 'light', colorName = 'text' } = option || {};

    const color = typeof option === 'string' ? option : option?.color || null;

    if (color === null)
        return null;
  
      if (color === 'transparent')
        return color;
      
      if (typeof color === 'string' && color === 'default')
        return colors.theme[ type ][ colorName ];
  
      //rgb or rgba colors
      if (typeof color === 'string' && color !== 'default' && color?.includes('.') && color.includes('rgb')) {
        return color;
      }
  
      //hexcolors
      if (typeof color === 'string' && color !== 'default' && color?.includes('#')) {
        return color;
      }
  
      //colorcode from colors.js
      if (typeof color === 'string' && color.includes('.')) {
        const [colorCode, colorBrithness, alpha] = color?.split('.'); 
        
        if (alpha > 0 && alpha < 100) {
          //convert hex value to rgba + alpha to hex
          const hex = colors[colorCode][colorBrithness];
          const alphaHex = Math.round(alpha / 100 * 255);
          const alphaHexed = alphaHex.toString(16).padStart(2, '0');
          return hex + alphaHexed;
        }
  
        return colors[colorCode][colorBrithness];
      }
  
      if (typeof color === 'string' && color !== 'default')
        return color;
  
      if (typeof color === 'object' && typeof color?.$$typeof == 'symbol')
        return color;
      
      return colors['theme'][type][colorName];
});